<template>
  <!-- 新数据目的 -->
  <div class="">
    <v-dialog
      class="popbox"
      name="dialog2"
      v-model="isShow"
      :title="dialogTitle"
      close-on-click-modal
      :modal="true"
      :width="668"
      @after-close="handleAfterClose"
      @confirm="handleConfirm"
      append-to-body
    >

      <v-form ref="form" :model="ruleForm" :rules="rules">

        <v-form-item  prop="dest_name" >
          <template slot="label">
            <span class="required">*</span>
            <span>数据目的名称</span>
          </template>
          <v-input type="text" name="dest_name" v-model="ruleForm.dest_name"></v-input>
        </v-form-item>
        <v-form-item  prop="dest_type" >
          <template slot="label">
            <span class="required">*</span>
            <span>数据目的类型</span>
          </template>
          <v-select id="dest_type" @change="changetype" name="dest_type" v-model="ruleForm.dest_type" :options="destTypeOptins"></v-select>
        </v-form-item>

        <v-form-item  prop="interface" v-if="ruleForm.dest_type == 'INTERFACE'" key="interface">
          <template slot="label">
            <span class="required">*</span>
            <span>接口路径</span>
          </template>
          <v-input type="text" name="interface" v-model="ruleForm.interface"></v-input>
        </v-form-item>
        <v-form-item  prop="method" v-if="ruleForm.dest_type == 'INTERFACE'" key="dest_type1">
          <template slot="label">
            <span class="required">*</span>
            <span>请求方法</span>
          </template>
          <v-select id="method" name="method" v-model="ruleForm.method" :options="methodOptins"></v-select>
        </v-form-item>


        <v-form-item  prop="topic" v-if="ruleForm.dest_type != 'INTERFACE'" key="topic1">
          <template slot="label">
            <span class="required">*</span>
            <span>Topic</span>
          </template>
            <v-input  type="text" name="topic" v-model="ruleForm.topic"></v-input>
        </v-form-item>

        <v-form-item  prop="method" :required="false" v-if="ruleForm.dest_type == 'MQ'" key="dest_type2">
          <template slot="label">
            <span class="required"></span>
            <span>方法
              <v-col :offset="1" :span="2" class="contents">
                    <v-tooltip
                      class="v-tooltip-top"
                      :max-width="310"
                      content="方法：此方法为业务区隔，同一个Topic可以根据不同方法实现不同业务场景。可选"
                      trigger="click"
                      position="top-center"
                    >
                      <span><img src="../../../assets/img/tips.png" alt=""></span>
                    </v-tooltip>
                </v-col>
            </span>
          </template>
          <v-input type="text" name="method2" v-model="ruleForm.method"></v-input>
        </v-form-item>

        <v-form-item  prop="dest_desc" key="dest_desc">
          <template slot="label">
            <span class="required">*</span>
            <span>描述</span>
          </template>
          <v-input type="textarea" class="remarks" name="dest_desc" :maxlength="200" v-model="ruleForm.dest_desc" show-word-limit></v-input>
        </v-form-item>

      </v-form>
    </v-dialog>

  </div>

</template>

<script>
import { copy } from '@/common/libs/utils';

export default {
  components: {},
  props:{
  showInputDialog:{
    type:Boolean,
    default: false
  },
},
  data() {
    return {
      rules: {
        dest_name: copy([{
          type: "nameInput"
        }]),
        topic: copy([{
          type: "topicinfo"
        }]),
      },
      ruleForm:{
        dest_name: "",
        dest_desc: "",
        dest_type: 'MQTT', //类型
        interface: '', //接口参数
        method:'',
        topic:'',
        app_id: sessionStorage.getItem("appid") || "",
      },
      destTypeOptins:[
        {
          label:'MQTT',
          value:'MQTT'
        },
        {
          label:'接口',
          value:'INTERFACE'
        },
        {
          label:'消息队列',
          value:'MQ'
        }
      ],
      methodOptins: ['POST'],
      // methodOptins: ['GET', 'POST', 'PUT', 'DELETE'],
      topicList:[],
      dialogTitle: "创建数据目的",

      isShow:false,
      nodata:{},
    };
  },
  created() {
    this.nodata = copy(this.ruleForm)
  },
  watch:{
    showInputDialog(newVal){
      this.isShow = newVal
    },
  },
  methods: {
    changetype(){
      this.ruleForm.topic = ''
    },
    handleConfirm() {
      const valid = this.$refs.form.submitForm();
      if (valid === false) {
        return;
      }
      let submitData = { ...this.ruleForm };
      this.$post("/td/td-iot-api/iot/rule/dest/v1", submitData, false).then((res) => {
        let code = +res.code;
        if (code === 0) {
          this.$emit('getData')
          this.$message.success(res.msg);
        }
        else {
          this.$message.error(res.msg);
        }
      });
      this.ruleForm = copy(this.nodata)
      this.changetype()
      this.$emit('update:showInputDialog',false)
      Object.assign(this.$data, this.$options.data())
    },
    handleAfterClose() {
      this.ruleForm = copy(this.nodata)
      this.changetype()
      this.$emit('update:showInputDialog',false)
      Object.assign(this.$data, this.$options.data())
    }
  },
  beforeDestroy() {},
};
</script>

<style lang="scss">

</style>
